
import Vue from 'vue'
import { mapGetters } from 'vuex'

import Breadcrumbs from '@/components/Breadcrumbs.vue'
import UserInfo from '@/components/UserInfo.vue'
import { GetterTypes as FeatureFlagGetters } from '@/store/modules/feature-flags/feature-flags.getters'

export default Vue.extend({
  name: 'App',
  components: { Breadcrumbs, UserInfo },
  methods: {
    login() {
      this.$auth.loginWithRedirect()
    }
  },
  computed: {
    ...mapGetters({
      getFlagValue: FeatureFlagGetters.GET_FLAG_BY_NAME
    })
  },
  watch: {
    '$route.params': {
      handler: function (params) {
        const { companyId, folderId } = params

        if (companyId) {
          this.$store.dispatch('GET_FOLDERS', companyId)
        }
        if (folderId) {
          this.$store.dispatch('GET_TECHPACKS', { id: folderId, company: companyId })
        }
      },
      deep: true,
      immediate: true
    }
  }
})
